// Values to choose from Jira (issue types, statuses) as toggles; until they are known (no
// token, no project yet), typed freely.
import { useT } from "../../../i18n";
import { ChipInput } from "../../../ui/ChipInput";
import { FieldSet } from "../../../ui/Segmented";
import { ToggleChips } from "../../../ui/ToggleChips";

export function ChoicesField({
  legend,
  hint,
  options,
  value,
  onChange,
}: {
  legend: string;
  hint: string;
  options: string[];
  value: string[];
  onChange: (next: string[]) => void;
}) {
  const t = useT().tasks.create.jira;
  if (options.length === 0) {
    return (
      <div>
        <ChipInput label={legend} values={value} onChange={onChange} placeholder={t.typeValue} removeLabel={t.remove} />
        <p className="mb-0 mt-1.5 text-[13px] text-gray-500">{hint}</p>
      </div>
    );
  }
  const all = [...options, ...value.filter((v) => !options.includes(v))];
  return (
    <FieldSet legend={legend} hint={hint}>
      <ToggleChips label={legend} options={all} value={value} onChange={onChange} />
    </FieldSet>
  );
}
